module.exports = window["nab"]["conversionActions"];